<!--
 * @Descripttion: 注册页面组件
 * @Author: congz
 * @Date: 2020-06-11 10:01:19
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 19:58:16
--> 

<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="item">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="nickname">
              <el-input v-model="form.nickname" placeholder="Nickname"></el-input>
            </el-form-item>
            <el-form-item prop="user_name">
              <el-input v-model="form.user_name" placeholder="Username"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="Phone Number"></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value" class="otp-item">
              <span class="math-captcha" title="Click to refresh" @click="refreshCaptcha">{{ captchaExpression }} = ?</span>
              <el-input v-model="form.captcha_value" placeholder="Answer" class="otp-input"></el-input>
            </el-form-item>
            <el-form-item prop="otp_code" class="otp-item">
              <el-input v-model="form.otp_code" placeholder="Verification Code" class="otp-input"></el-input>
              <a href="javascript:;" class="btn-gradient desert otp-btn" :class="{ disabled: otpSending }" @click="sendOtp">
                {{ otpText }}
              </a>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="Password" type="password"></el-input>
            </el-form-item>
            <el-form-item prop="password_confirm">
              <el-input v-model="form.password_confirm" placeholder="Confirm Password" type="password"></el-input>
            </el-form-item>
          </el-form>
<!--          <div id="captcha">-->
<!--            <p id="wait">Loading verification code ...</p>-->
<!--          </div>-->
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="register('form')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script src="../assets/gt.js"></script>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
require('../assets/gt.js')
var captcha
export default {
  name: 'Register',
  data() {
    var validateNick = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter a nickname'))
      } else if (value.length < 2 || value.length > 10) {
        callback(new Error('Nickname length should be between 2 and 10'))
      }
      callback()
    }
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      } else {
        if (this.form.password_confirm !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.form.password) {
        callback(new Error('The password entered twice is inconsistent!'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      const phoneRegex = /^\d{10}$/
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (!phoneRegex.test(value.replace(/\D/g, ''))) {
        callback(new Error('Please enter a valid 10-digit phone number'))
      } else {
        callback()
      }
    }
    var validateOtp = (rule, value, callback) => {
      const otpRegex = /^\d{6}$/
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (!otpRegex.test(value)) {
        callback(new Error('Verification code must be 6 digits'))
      } else {
        callback()
      }
    }
    var validateCaptcha = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the math captcha answer'))
      } else {
        callback()
      }
    }
    return {
      imageUrl: '',
      form: {
        nickname: '',
        user_name: '',
        phone: '',
        captcha_value: '',
        otp_code: '',
        password: '',
        password_confirm: '',
        challenge: '',
        validate: '',
        seccode: ''
      },
      rules: {
        nickname: [{ validator: validateNick, trigger: 'blur' }],
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        captcha_value: [{ validator: validateCaptcha, trigger: 'blur' }],
        otp_code: [{ validator: validateOtp, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        password_confirm: [{ validator: validatePass2, trigger: 'blur' }]
      },
      captchaID: 0,
      captchaExpression: '',
      otpSending: false,
      otpCountdown: 0,
      otpTimer: null
    }
  },
  computed: {
    otpText() {
      if (this.otpCountdown > 0) {
        return `${this.otpCountdown}s`
      }
      return this.otpSending ? 'Sending...' : 'Send Code'
    }
  },
  methods: {
    ...mapActions(['setUser']),
    refreshCaptcha() {
      var self = this
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200 && res.data) {
          self.captchaID = res.data.captcha_id
          self.captchaExpression = res.data.expression
        }
      })
      this.form.captcha_value = ''
    },
    startOtpCountdown() {
      this.otpCountdown = 60
      this.otpTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--
        } else {
          clearInterval(this.otpTimer)
          this.otpSending = false
        }
      }, 1000)
    },
    sendOtp() {
      this.$refs.form.validateField('phone', errorMessage => {
        if (errorMessage) {
          return
        }
        if (this.otpSending || this.otpCountdown > 0) {
          return
        }
        this.$refs.form.validateField('captcha_value', errorMessage => {
          if (errorMessage) {
            return
          }
          this.otpSending = true
          const phone = this.form.phone.replace(/\D/g, '')
          userAPI
            .sendOtp({ phone: phone, captcha_id: this.captchaID, captcha_value: this.form.captcha_value })
            .then(res => {
              if (res.status === 200) {
                this.notifySucceed('Verification code sent')
                this.startOtpCountdown()
                // 数学验证码一次性：发送成功后刷新
                this.refreshCaptcha()
              } else {
                this.otpSending = false
                // 数学验证码错误时也刷新，避免旧验证码重复试错
                if (res.status === 20016) {
                  this.refreshCaptcha()
                }
                this.notifyError('Failed to send code', res.msg)
              }
            })
            .catch(error => {
              this.otpSending = false
              this.notifyError('Failed to send code', error)
            })
        })
      })
    },
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        // var result = captcha.getValidate()
        // if (!result) {
        //   this.notifyError('Please verify', null)
        //   return
        // }
        // ;(this.form.challenge = result.geetest_challenge),
        //   (this.form.validate = result.geetest_validate),
        //   (this.form.seccode = result.geetest_seccode),
          const submitForm = Object.assign({}, this.form)
          submitForm.phone = submitForm.phone.replace(/\D/g, '')
          userAPI
            .postUser(submitForm)
            .then(res => {
              if (res.status === 404) {
                this.notifyError('Verification failed', res.msg)
              } else if (res.status === 200) {
                // 注册成功即自动登录：保存登录信息到本地
                let user = JSON.stringify(res.data.user)
                localStorage.setItem('user', user)
                localStorage.setItem('token', res.data.token)
                // 登录信息存到vuex（header 登录态依赖 vuex）
                this.setUser(res.data.user)
                this.notifySucceed('registered successfully')
                this.$router.push({
                  name: 'Home'
                })
              } else {
                this.notifyError('Registration failed', res.msg)
              }
            })
            .catch(error => {
              this.notifyError('Registration failed', error)
            })
      })
    },
    init_geetest() {
      userAPI.geetest().then(res => {
        window.initGeetest(
          {
            gt: res.gt,
            challenge: res.challenge,
            new_captcha: res.new_captcha,
            offline: !res.success,
            product: 'popup',
            width: '100%'
          },
          function(captchaObj) {
            captcha = captchaObj
            captchaObj.appendTo('#captcha')
            captchaObj.onReady(function() {
              document.getElementById('wait').style.display = 'none'
            })
          }
        )
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
    this.init_geetest()
  },
  beforeDestroy() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer)
    }
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}

.otp-item ::v-deep .el-form-item__content {
  display: flex;
}

.math-captcha {
  width: 90px;
  line-height: 38px;
  margin-right: 10px;
  text-align: center;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 15px;
  font-weight: bold;
  color: #444;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
}

.otp-input {
  flex: 1;
  margin-right: 10px;
}

.otp-btn {
  width: 110px;
  padding: 0;
  line-height: 38px;
  text-align: center;
  font-size: 13px;
}

.otp-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
